module.exports = __webpack_public_path__ + "img/example2.b1dba215.jpg";